import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { KYB } from "../../src/landingPage/views/Usecases/KYB/KYB";

const KybPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/kyb-workflow-automation"
        title={meta.usecases.kyb.title}
        description={meta.usecases.kyb.description}
      />
      <KYB />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default KybPage;
